import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Typography, Button } from "@material-tailwind/react";

const PORTAL_API_BASE = (
  process.env.REACT_APP_PORTAL_API_URL ||
  "https://n4qh9nwqv5.execute-api.us-east-1.amazonaws.com/prod"
).replace(/\/$/, "");

export default function NewsletterSection({ compact = false }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null); // success | error
  const [message, setMessage] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    if (!consent) {
      setStatus("error");
      setMessage("Debes aceptar el aviso de privacidad.");
      return;
    }
    setSubmitting(true);
    setStatus(null);
    setMessage("");
    try {
      const res = await fetch(`${PORTAL_API_BASE}/revista/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name.trim(),
          email: email.trim(),
          consent: true,
          source: "website",
        }),
      });
      let data = {};
      try {
        data = await res.json();
      } catch {
        /* ignore */
      }
      if (!res.ok) {
        throw new Error(data?.error || data?.message || "No se pudo enviar la suscripción");
      }
      setStatus("success");
      setMessage(data?.message || "Revisa tu correo para descargar Conexión Siete.");
      setName("");
      setEmail("");
      setConsent(false);
    } catch (err) {
      setStatus("error");
      setMessage(err?.message || "No se pudo enviar la suscripción");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section id="conexion-siete" className={compact ? "bg-white py-12 sm:py-16" : "bg-brand-beige py-14 sm:py-20"}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8">
          <Typography variant="h3" className="text-brand-navy font-normal mb-2">
            {compact ? "Suscríbete a Conexión Siete" : "Conexión Siete"}
          </Typography>
          <Typography className="text-brand-gray text-base leading-relaxed max-w-xl mx-auto">
            Recibe el ejemplar vigente por correo, con ideas prácticas de bienestar
            organizacional.
            {!compact ? (
              <>
                {" "}
                También puedes ver todas las ediciones en{" "}
                <Link to="/conexion-siete" className="text-brand-lavender font-medium hover:underline">
                  Conexión Siete
                </Link>
                .
              </>
            ) : null}
          </Typography>
        </div>

        {status === "success" ? (
          <div className="rounded-xl border border-brand-lilac bg-white p-6 text-center">
            <Typography className="font-semibold text-brand-navy text-lg">
              Listo — revisa tu bandeja
            </Typography>
            <p className="text-sm text-brand-gray mt-2 leading-relaxed">{message}</p>
          </div>
        ) : (
          <form
            onSubmit={onSubmit}
            className="rounded-xl border border-brand-lilac/60 bg-white p-6 sm:p-8 space-y-4 shadow-sm"
          >
            <div>
              <label htmlFor="conexion-name" className="block text-sm font-medium text-brand-navy mb-1">
                Nombre
              </label>
              <input
                id="conexion-name"
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full bg-brand-beige/60 p-3 rounded-md outline-none focus:ring-2 focus:ring-brand-lavender"
                autoComplete="name"
              />
            </div>
            <div>
              <label htmlFor="conexion-email" className="block text-sm font-medium text-brand-navy mb-1">
                Correo electrónico
              </label>
              <input
                id="conexion-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-brand-beige/60 p-3 rounded-md outline-none focus:ring-2 focus:ring-brand-lavender"
                autoComplete="email"
              />
            </div>
            <label className="flex items-start gap-2 text-sm text-brand-gray cursor-pointer">
              <input
                type="checkbox"
                className="mt-1 rounded border-brand-lavender/40"
                checked={consent}
                onChange={(e) => setConsent(e.target.checked)}
              />
              <span>
                Acepto el{" "}
                <Link
                  to="/politica-privacidad"
                  className="text-brand-lavender font-medium hover:underline"
                >
                  aviso de privacidad
                </Link>{" "}
                y deseo recibir Conexión Siete por correo.
              </span>
            </label>

            {status === "error" && message ? (
              <p className="text-sm text-red-600" role="alert">
                {message}
              </p>
            ) : null}

            <Button
              type="submit"
              disabled={submitting}
              className="w-full sm:w-auto bg-brand-navy hover:bg-brand-lavender text-white rounded-md normal-case tracking-wide shadow-none"
            >
              {submitting ? "Enviando…" : "Suscribirme y recibir PDF"}
            </Button>
          </form>
        )}
      </div>
    </section>
  );
}
